"use client";
import React, { useState } from "react";
import { Link } from "react-router-dom";
export default function Affiliates() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    friendlyUrl: "",
    loadOrders: false,
  });
  const [affiliates, setAffiliates] = useState([
    { id: 1, firstName: "John", lastName: "Smith", active: true },
    { id: 2, firstName: "Alice", lastName: "Brown", active: false },
  ]);
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };
  const handleSearch = () => alert("Search clicked!");
  const handleAddNew = () => alert("Add new affiliate clicked!");
  return (
    <div className="p-6 space-y-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="flex flex-wrap justify-between items-center gap-4">
        <h2 className="text-2xl font-semibold text-gray-800">Affiliates</h2>
        <button
          onClick={handleAddNew}
          className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-md shadow-md"
        >
          + Add New
        </button>
      </div>
      {/* Search Panel */}
      <div className="bg-white shadow-md rounded-lg p-5">
        <h3 className="text-lg font-semibold text-gray-700 flex items-center mb-4">
          <svg
            className="w-5 h-5 text-gray-500 mr-2"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-4.35-4.35M9.5 17a7.5 7.5 0 100-15 7.5 7.5 0 000 15z"
            />
          </svg>
          Search
        </h3>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              First Name
            </label>
            <input
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              className="mt-1 block w-full border border-gray-300 rounded-md p-2"
              placeholder="Enter first name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Last Name
            </label>
            <input
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              className="mt-1 block w-full border border-gray-300 rounded-md p-2"
              placeholder="Enter last name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Friendly URL name
            </label>
            <input
              name="friendlyUrl"
              value={formData.friendlyUrl}
              onChange={handleChange}
              className="mt-1 block w-full border border-gray-300 rounded-md p-2"
              placeholder="friendly-url"
            />
          </div>
          <div className="flex items-center space-x-2 mt-2 md:col-span-2">
            <input
              type="checkbox"
              name="loadOrders"
              checked={formData.loadOrders}
              onChange={handleChange}
              className="w-4 h-4"
            />
            <label className="text-sm text-gray-700">
              Load only with orders
            </label>
          </div>
        </div>
        <div className="mt-4">
          <button
            onClick={handleSearch}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md flex items-center space-x-2"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-4.35-4.35M9.5 17a7.5 7.5 0 100-15 7.5 7.5 0 000 15z"
              />
            </svg>
            <span>Search</span>
          </button>
        </div>
      </div>
      {/* Info Section */}
      <div className="bg-white p-4 rounded-lg shadow text-sm text-gray-700">
        Affiliates is an Internet-based marketing practice in which a business
        rewards one or more affiliates for each visitor or customer.
        <a href="#" className="text-blue-600 underline ml-1">
          Learn more about affiliates
        </a>
      </div>
      {/* Affiliates Table */}
      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="min-w-full text-left">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="p-3">First Name</th>
              <th className="p-3">Last Name</th>
              <th className="p-3">Active</th>
              <th className="p-3 text-right">Edit</th>
            </tr>
          </thead>
          <tbody>
            {affiliates.map((a) => (
              <tr key={a.id} className="border-t hover:bg-gray-50">
                <td className="p-3">{a.firstName}</td>
                <td className="p-3">{a.lastName}</td>
                <td className="p-3">
                  {a.active ? (
                    <span className="text-green-600 font-bold">✔</span>
                  ) : (
                    "✖"
                  )}
                </td>
                <td className="p-3 text-right">
                  <Link
                    to={`/affiliates/${a.id}/edit`}
                    className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-md shadow-sm"
                  >
                    Edit
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* Pagination */}
        <div className="flex justify-between items-center p-3 text-sm text-gray-600 flex-wrap">
          <div className="flex space-x-2 items-center">
            <button className="px-3 py-1 border rounded">Previous</button>
            <span className="px-3 py-1 bg-blue-600 text-white rounded">
              1
            </span>
            <button className="px-3 py-1 border rounded">Next</button>
          </div>
          <p>1-2 of 2 items</p>
        </div>
      </div>
    </div>
  );
}
